/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: AlignmentShapeControl.ts
 * Project: mle-client-n
 * Committed last: 2022/1/29 @ 1228
 * ---
 * Description:
 */

import {
  HorizontalAlignment
}                                               from '@revodigital/pamela/lib/configuration/Alignment';
import { ControlTypes }                         from '../../selection-properties';
import { ShapeControl, ShapeControlInitParams } from './ControlGroup';

/**
 * Controllo per gestire l'allineamento orizzontale di un testo.
 */
export class AlignmentShapeControl extends ShapeControl<HorizontalAlignment> {
  public enableJustify: boolean;

  constructor(initParams: ShapeControlInitParams<HorizontalAlignment>, { enableJustify }: { enableJustify: boolean }) {
    super(initParams);
    this.controlType = ControlTypes.ALIGN_SELECT;
    this.enableJustify = enableJustify;
  }
}